/**
 * One change a device sends to the import endpoint (see `database.md`, "Server: import
 * endpoint"), by column name. The device exports them from its change log, or from whole tables
 * when the log cannot be read; the gateway applies them with an upload's rules.
 */
export type ActorSyncImportChange =
  | { id: string; kind: "delete"; table: string }
  | { kind: "insert" | "update"; row: Record<string, unknown>; table: string };

/** At most this many changes in one request; the device sends more as parts. */
export const ACTOR_SYNC_IMPORT_CHANGES_PER_PART = 400;
